import { useEffect } from "react"

const useOutsideClick = (id: string, handler: (event: MouseEvent | TouchEvent) => void) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      const element = document.getElementById(id)

      if (!element) {
        return
      }

      const target = event.target as Node

      // Check if the target itself has the same id or if any of its parents do
      const isTargetOrContained =
        (target instanceof HTMLElement && target.id === id) || manuallyCheckIfHasId(id, target)

      if (!isTargetOrContained) {
        handler(event)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    document.addEventListener("touchstart", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
      document.removeEventListener("touchstart", handleClickOutside)
    }
  }, [id, handler])
}

const manuallyCheckIfHasId = (id: string, node: Node | null): boolean => {
  while (node) {
    if (node instanceof HTMLElement && node.id === id) {
      return true
    }
    node = node.parentNode as Node
  }
  return false
}

export default useOutsideClick
